<ng-container *transloco="let t; read: 'noCourseModal'">

    <div class="wrapper {{this.class}}" *ngIf="this.futureGroup">
        <div class="image">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5812_12551)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M32.0488 9.99805C31.4779 9.99805 30.9128 10.1121 30.3865 10.3336C29.8637 10.5535 29.3899 10.875 28.9925 11.2794L11.1704 28.9871C10.9307 29.2254 10.7832 29.5406 10.7541 29.8771L10.0112 38.4486C9.97479 38.8688 10.126 39.2837 10.4243 39.5823C10.7226 39.8806 11.1375 40.0317 11.5578 39.9951L20.1292 39.2523C20.4658 39.2231 20.7811 39.0757 21.0193 38.836L38.7262 21.0148L38.7305 21.0106C39.1302 20.613 39.4474 20.1406 39.6642 19.6202C39.8819 19.0979 39.9939 18.5378 39.9939 17.972C39.9939 17.4062 39.8819 16.846 39.6642 16.3238C39.4476 15.8036 39.1302 15.3312 38.7308 14.9338L35.1131 11.2875L35.1088 11.2834C34.7105 10.8771 34.2354 10.5542 33.7111 10.3336C33.1848 10.1121 32.6197 9.99805 32.0488 9.99805Z"
                          fill="#83B25F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12.8031 1.84935C12.2382 -0.627521 8.70459 -0.612075 8.16133 1.86963L8.13879 1.97299L8.09387 2.17741C7.41962 5.19667 4.99159 7.51359 1.94157 8.04419C-0.639387 8.49322 -0.639367 12.1983 1.94157 12.6473C5.00224 13.1798 7.43656 15.511 8.1009 18.5458L8.16133 18.8218C8.70459 21.3036 12.2382 21.319 12.8031 18.8421L12.8765 18.5204C13.5661 15.4971 16.0034 13.1834 19.0584 12.6518C21.6445 12.2019 21.6445 8.48953 19.0584 8.03965C16.0196 7.51096 13.592 5.21887 12.8876 2.21917C12.8684 2.13704 12.8504 2.05795 12.8312 1.97291L12.8031 1.84935Z"
                          fill="#3F403F"/>
                </g>
                <defs>
                    <clipPath id="clip0_5812_12551">
                        <rect width="40" height="40" fill="white"/>
                    </clipPath>
                </defs>
            </svg>

        </div>

        <div class="title">
            OOPS
        </div>

        <div class="teaser" *ngIf="isParentRole">
            {{ t('future.parent.title') }}


        </div>

        <div class="teaser" *ngIf="!isParentRole">
            {{ 'noCourseModal.future.child.title'|transloco }}
        </div>

        <div class="btn-wrapper">

            <button type="button" class="btn dark-btn" (click)="openRequestModal('continueStudy')"> {{ t('toStudy') }}
            </button>

        </div>


    </div>

    <div class="wrapper current {{this.class}}" *ngIf="this.currentGroup">
        <div class="image">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5812_12551)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M32.0488 9.99805C31.4779 9.99805 30.9128 10.1121 30.3865 10.3336C29.8637 10.5535 29.3899 10.875 28.9925 11.2794L11.1704 28.9871C10.9307 29.2254 10.7832 29.5406 10.7541 29.8771L10.0112 38.4486C9.97479 38.8688 10.126 39.2837 10.4243 39.5823C10.7226 39.8806 11.1375 40.0317 11.5578 39.9951L20.1292 39.2523C20.4658 39.2231 20.7811 39.0757 21.0193 38.836L38.7262 21.0148L38.7305 21.0106C39.1302 20.613 39.4474 20.1406 39.6642 19.6202C39.8819 19.0979 39.9939 18.5378 39.9939 17.972C39.9939 17.4062 39.8819 16.846 39.6642 16.3238C39.4476 15.8036 39.1302 15.3312 38.7308 14.9338L35.1131 11.2875L35.1088 11.2834C34.7105 10.8771 34.2354 10.5542 33.7111 10.3336C33.1848 10.1121 32.6197 9.99805 32.0488 9.99805Z"
                          fill="#83B25F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12.8031 1.84935C12.2382 -0.627521 8.70459 -0.612075 8.16133 1.86963L8.13879 1.97299L8.09387 2.17741C7.41962 5.19667 4.99159 7.51359 1.94157 8.04419C-0.639387 8.49322 -0.639367 12.1983 1.94157 12.6473C5.00224 13.1798 7.43656 15.511 8.1009 18.5458L8.16133 18.8218C8.70459 21.3036 12.2382 21.319 12.8031 18.8421L12.8765 18.5204C13.5661 15.4971 16.0034 13.1834 19.0584 12.6518C21.6445 12.2019 21.6445 8.48953 19.0584 8.03965C16.0196 7.51096 13.592 5.21887 12.8876 2.21917C12.8684 2.13704 12.8504 2.05795 12.8312 1.97291L12.8031 1.84935Z"
                          fill="#3F403F"/>
                </g>
                <defs>
                    <clipPath id="clip0_5812_12551">
                        <rect width="40" height="40" fill="white"/>
                    </clipPath>
                </defs>
            </svg>

        </div>

        <div class="teaser" *ngIf="isParentRole">
            {{ t('current.parent.title') }}


        </div>

        <div class="teaser" *ngIf="!isParentRole">

            {{ t('current.child.title') }}

        </div>


    </div>

    <div class="wrapper {{this.class}}" *ngIf="this.pastGroup">

        <div class="image">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5812_12551)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M32.0488 9.99805C31.4779 9.99805 30.9128 10.1121 30.3865 10.3336C29.8637 10.5535 29.3899 10.875 28.9925 11.2794L11.1704 28.9871C10.9307 29.2254 10.7832 29.5406 10.7541 29.8771L10.0112 38.4486C9.97479 38.8688 10.126 39.2837 10.4243 39.5823C10.7226 39.8806 11.1375 40.0317 11.5578 39.9951L20.1292 39.2523C20.4658 39.2231 20.7811 39.0757 21.0193 38.836L38.7262 21.0148L38.7305 21.0106C39.1302 20.613 39.4474 20.1406 39.6642 19.6202C39.8819 19.0979 39.9939 18.5378 39.9939 17.972C39.9939 17.4062 39.8819 16.846 39.6642 16.3238C39.4476 15.8036 39.1302 15.3312 38.7308 14.9338L35.1131 11.2875L35.1088 11.2834C34.7105 10.8771 34.2354 10.5542 33.7111 10.3336C33.1848 10.1121 32.6197 9.99805 32.0488 9.99805Z"
                          fill="#83B25F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12.8031 1.84935C12.2382 -0.627521 8.70459 -0.612075 8.16133 1.86963L8.13879 1.97299L8.09387 2.17741C7.41962 5.19667 4.99159 7.51359 1.94157 8.04419C-0.639387 8.49322 -0.639367 12.1983 1.94157 12.6473C5.00224 13.1798 7.43656 15.511 8.1009 18.5458L8.16133 18.8218C8.70459 21.3036 12.2382 21.319 12.8031 18.8421L12.8765 18.5204C13.5661 15.4971 16.0034 13.1834 19.0584 12.6518C21.6445 12.2019 21.6445 8.48953 19.0584 8.03965C16.0196 7.51096 13.592 5.21887 12.8876 2.21917C12.8684 2.13704 12.8504 2.05795 12.8312 1.97291L12.8031 1.84935Z"
                          fill="#3F403F"/>
                </g>
                <defs>
                    <clipPath id="clip0_5812_12551">
                        <rect width="40" height="40" fill="white"/>
                    </clipPath>
                </defs>
            </svg>

        </div>

        <div class="teaser" *ngIf="isParentRole">
            {{ t('past.parent.title') }}


        </div>

        <div class="teaser" *ngIf="!isParentRole">
            {{ t('past.child.title') }}

        </div>


    </div>
</ng-container>
